module.exports = __WEBPACK_EXTERNAL_MODULE_13__;


//////////////////
// WEBPACK FOOTER
// external "@ng-idle/keepalive"
// module id = 13
// module chunks = 0